/*********************************************************************************************
* Splide tabs
    *
*/
document.addEventListener('DOMContentLoaded', function() {
    var splideSections = document.querySelectorAll('[data-section-products-id]');
    
    splideSections.forEach(function(section) {
        var splideElem = section.querySelector('.splide-products-tabs');
        
        if (splideElem) {
            new Splide(splideElem, {
                type: 'slide',
                arrows: false,
                pagination: false,
                perPage: 1,
                drag: 'free',
                snap: true,    
                gap: '6px',
                breakpoints: {
                    768: {
                    }
                }
            }).mount();
        }
    });
});
